import { Injectable, inject } from '@angular/core';
import { LoadableDataSource, LocalDataSource } from '@vdms-hq/shared';
import { ViewSettingsService } from '@vdms-hq/view-settings';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ApiFieldsSourceService, FieldTypeViewModel, FieldValueViewModel } from '@vdms-hq/selectors';

@Injectable({ providedIn: 'root' })
export class FieldValuesDataSource extends LocalDataSource<FieldValueViewModel> implements LoadableDataSource {
  private readonly fieldsSourceService: ApiFieldsSourceService = inject(ApiFieldsSourceService);
  private readonly viewSettingsService = inject(ViewSettingsService);

  public isLoading$ = this.fieldsSourceService.isLoading$;

  readonly #typeFilter$: BehaviorSubject<FieldTypeViewModel | null> = new BehaviorSubject<FieldTypeViewModel | null>(
    null,
  );
  public allData$ = combineLatest([this.fieldsSourceService.fields$, this.#typeFilter$]).pipe(
    map(([fields, type]) => (type ? fields.filter((field) => field.type.uuid === type.uuid) : fields)),
  );

  constructor() {
    super();
    this.initialize();

    this.viewSettingsService.perPageUserSettings$.pipe(take(1)).subscribe((perPage) => {
      this.pageSize$.next(perPage);
    });
  }

  setTypeFilter(type: FieldTypeViewModel | null) {
    this.#typeFilter$.next(type);
  }

  optionsDeleted() {
    this.fieldsSourceService.refreshAll();
  }
}
